import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import NewPill from 'core/modules/NewPill/NewPill';
import ExtraRewardsPill from 'core/modules/ExtraRewardsPill/ExtraRewardsPill';
import { isSameDomain } from 'core/utils/helpers/url';

const checkIsActiveNavUrl = (location, navUrl) => {
  try {
    const sameDomain = isSameDomain(navUrl, window.location.hostname);
    if (navUrl === '#' || !sameDomain) return false;
    const navUrlPathname = new URL(navUrl, window.location.origin).pathname;
    return location.pathname === navUrlPathname;
  } catch (e) {
    return false;
  }
};

function MainNavItemWithoutSubnav({
  url, label, title, className, newPillEnabled, ...attrs
}) {
  const location = useLocation();
  const isActiveNavUrl = checkIsActiveNavUrl(location, url);

  return (
    <div className={`mn_navigationListItem ${className}`}>
      <a href={url} {...attrs}>
        <span className={`mn_navItemLabel ${isActiveNavUrl ? 'mn_active' : ''}`}>
          {newPillEnabled && <NewPill />}
          <ExtraRewardsPill url={url} label={label} />
          {title}
        </span>
      </a>
    </div>
  );
}

MainNavItemWithoutSubnav.propTypes = {
  url: PropTypes.string,
  title: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  newPillEnabled: PropTypes.bool,
};

MainNavItemWithoutSubnav.defaultProps = {
  className: '',
  newPillEnabled: false,
  url: null,
};

export default MainNavItemWithoutSubnav;
